export enum CheckoutProcessStep {
    Shipping = 1,
    ShippingMethod = 2,
    Payment = 3,
    Review = 4,
}
